import styled from "styled-components";

export const Container = styled.main`
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div:nth-child(1) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    padding: 18px;

    figure {
      width: 180px;
      margin-bottom: 40px;

      img {
        width: 100%;
      }
    }

    form {
      width: 296px;
      height: 230px;

      padding: 24px;
      border-radius: 5px;

      background-color: var(--gray-bg);

      h1 {
        font-size: 1.5rem;
        font-weight: 400;

        margin-bottom: 40px;
      }

      div {
        display: flex;
        flex-direction: column;

        label {
          text-transform: uppercase;
          font-size: 0.75rem;
          font-weight: bold;

          margin-bottom: 8px;
        }

        input {
          width: 100%;
          height: 40px;

          margin-bottom: 16px;

          padding: 10px;
        }
      }
    }
  }

  footer {
    width: 100%;
    height: 56px;
    background-color: #e8e8e880;

    position: fixed;
    bottom: 0;
    left: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    figure {
      width: 119px;

      img {
        width: 100%;
      }
    }
  }

  @media (min-width: 760px) {
    div:nth-child(1) {
      form {
        width: 388px;
        height: 243px;
      }
    }

    footer {
      display: none;
    }
  }
`;
